"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaLoader = void 0;
var _logger = require("@ori/logger");
var _react = _interopRequireWildcard(require("react"));
var _TopAreaSkeleton = require("./TopAreaSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; } /*
 * This wrapper ensures that even with an error in the TopArea.tsx file, the rest of the page
 * will still render and this will not be shown. This will also show skeleton while loading TopArea.tsx file.
 */
const TopArea = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require('./TopArea'))).then(module => ({
  default: module.TopArea
})));
const TopAreaLoader = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
  areaName: "TopAreaLoader",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopAreaSkeleton.TopAreaSkeleton, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TopArea, {})
  })
});
exports.TopAreaLoader = TopAreaLoader;
